module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-lock-a1381f31.svg";